import { apiFetch, setStoredToken } from './client';
import type { LoginResponse } from './types';

export async function localLogin(email: string, password: string): Promise<LoginResponse> {
  const res = await apiFetch<LoginResponse>('/auth/local/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
    authenticated: false,
  });
  setStoredToken(res.accessToken);
  return res;
}

export function logout(): void {
  setStoredToken(null);
}
